$(document)
  .on("click", ".evaluation-analytics-page .select-visibles", onShowSelectVisibles)
  .on("click", ".select-visible-inputs .cancel", onHideSelectVisibles)
  .on("click", ".select-visible-inputs .js-check-all", onCheckAll);

function onShowSelectVisibles() {
  $(".select-visible-inputs").show();
}

function onHideSelectVisibles(e) {
  e.preventDefault();
  e.stopPropagation();
  $(".select-visible-inputs").hide();
}

function onCheckAll(e) {
  e.preventDefault();
  e.stopPropagation();
  let $inputs = $(e.target).next().find("input[type=checkbox]");
  if ($inputs.length > 0) {
    if ($inputs.first().is(":checked")) {
      $inputs.prop("checked", false);
    } else {
      $inputs.prop("checked", true);
    }
  }
}
